import { moduleManager } from "@/services/module/module-manager";
import { watch } from "vue";

function updateVisibility(el, code, currentModuleManager) {
  const moduleIsAvailable = currentModuleManager.isModuleActive(code);

  el.classList.toggle("d-none", !moduleIsAvailable);
  el.hidden = !moduleIsAvailable;
}

export const moduleAvailable = {
  mounted(el, binding) {
    const currentModuleManager = moduleManager;
    el.__currentModuleManager = currentModuleManager;

    updateVisibility(el, binding.value.code, currentModuleManager);
    el.__watch = watch(
      () => currentModuleManager.isModuleActive(binding.value.code),
      () => {
        updateVisibility(el, binding.value.code, currentModuleManager);
      },
    );
  },
  updated(el, binding) {
    updateVisibility(el, binding.value.code, el.__currentModuleManager);
  },

  unmounted(el) {
    if (el.__watch) {
      el.__watch();
    }
    delete el.__currentModuleManager;
    delete el.__watch;
  },
};
